//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { transfer_fetchAll as fetchAll, destroy, _ORDER_TYPE, _ORDER_TYPE_COLOR } from '@/apis/order'
import { _STATUS, _STATUS_COLOR } from '@/apis/orderTransfer'

import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
                orderType: [],
            },
            searchQuery: {
                orderNo: "",
                phone: "",
                name: "",
                // venueCode: "",
                // fieldCode: "",
                orderType: "",
                status: "",
                sDate: "",
                eDate: "",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: 'ID', dataIndex: 'id', key: 'ID', width: 120 },
            { title: '訂單類型', key: 'orderType', scopedSlots: { customRender: 'orderTypeSlot' }, width: 120 },
            { title: '原訂單編號', dataIndex: 'sourceOrderNo', key: 'sourceOrderNo', width: 300 },
            { title: '客戶姓名', dataIndex: 'memberName', key: 'memberName', width: 180 },
            { title: '客戶手機', dataIndex: 'memberPhone', key: 'memberPhone', width: 180 },
            { title: '狀態', key: 'status', scopedSlots: { customRender: 'statusSlot' }, width: 160 },
            { title: '接收人', dataIndex: 'targetMemberName', key: 'targetMemberName', width: 330, },
            { title: '接收人電話', dataIndex: 'targetMemberPhone', key: 'targetMemberPhone', width: 330, },

            { title: '品牌', dataIndex: 'mchName', key: 'mchName', width: 180 },
            { title: '場館', dataIndex: 'venueName', key: 'venueName', width: 180 },
            { title: '場地', dataIndex: 'fieldName', key: 'fieldName', width: 180 },
            { title: '場次', dataIndex: 'timeSlotName', key: 'timeSlotName', width: 180 },
            { title: '日期', key: 'date', scopedSlots: { customRender: 'dateSlot' }, width: 180 },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, }
            
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {

        moment,
        onChangeOrderType(value) {
            let orderType = value.target.value;
            this.onPageLoad()
        },
        onChangeDate(value) {
            this.searchQuery.sDate = value[0].format('YYYY-MM-DD HH:mm')
            this.searchQuery.eDate = value[1].format('YYYY-MM-DD HH:mm')
        },
        

        async onPageConfig() {
            
            try {

                let _status = [], _order_type = [];

                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value]
                    })
                });
                this.config.status = _status;

                Object.keys(_ORDER_TYPE).forEach(value => {
                    _order_type.push({
                        id: value,
                        name: _ORDER_TYPE[value]
                    })
                });
                this.config.orderType = _order_type;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            const _this = this;
            records.forEach(order => {
                order.order_type_text = _this._getOrderTypeText(order.orderType);
                order.order_type_color = _this._getOrderTypeTextColor(order.orderType);
                order.order_status_text = _this._getOrderStatusText(order.status);
                order.order_status_color = _this._getOrderStatusColor(order.status);

            })

            return records;
        },
        _getOrderStatusText(value) {
            return _STATUS[value] !== undefined ? _STATUS[value] : '';
        },
        _getOrderStatusColor(value) {
            return _STATUS_COLOR[value] !== undefined ? _STATUS_COLOR[value] : '';
        },
        _getOrderTypeText(value) {
            return _ORDER_TYPE[value] !== undefined ? _ORDER_TYPE[value] : '-';
        },
        _getOrderTypeTextColor(value) {
            return _ORDER_TYPE_COLOR[value] !== undefined ? _ORDER_TYPE_COLOR[value] : '-';
        },
        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        }
    }
}
